// DS: C33A
/** Bottom section of a thumb, containing related information */ import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import Flex from '@wix/da-ds/pkg/Flex';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import DeviationLink from '../Duperbrowse/DeviationLink';
import Button from '../Button';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './ThumbInfo.scss';
const AVATAR_SIZE_DESKTOP = 32;
const AVATAR_SIZE_MOBILE = 24;
const ThumbInfo = ({ user , title , urlDeviation  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const kill_prints_act_two = useFlag('kill_prints_act_two');
    const showBuyPrintButton = !!urlDeviation.printId && !kill_prints_act_two;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], title ? s['with-title'] : s['without-title'])
    }, (!title || !isMobile) && /*#__PURE__*/ React.createElement(UserAvatar, {
        size: isMobile ? AVATAR_SIZE_MOBILE : AVATAR_SIZE_DESKTOP,
        user: user,
        className: s['avatar']
    }), !title && /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['username'],
        biData: {
            creatorid: user.useridUuid
        }
    }), title && /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, /*#__PURE__*/ React.createElement(DeviationLink, {
        className: s['title'],
        deviation: urlDeviation
    }, title), /*#__PURE__*/ React.createElement(Flex, {
        className: s['secondRow'],
        alignItems: "center"
    }, isMobile && /*#__PURE__*/ React.createElement(UserAvatar, {
        size: AVATAR_SIZE_MOBILE,
        user: user,
        className: s['avatar']
    }), /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['username'],
        biData: {
            creatorid: user.useridUuid
        }
    }))), showBuyPrintButton && /*#__PURE__*/ React.createElement("div", {
        className: s['print-buy']
    }, /*#__PURE__*/ React.createElement(Button, {
        view: "b18",
        height: "small",
        href: Url.printLink(urlDeviation.deviationId)
    }, t('common.buy'))));
};
ThumbInfo.displayName = 'ThumbInfo';
export default ThumbInfo;
